import React from "react";
import "./ExamPrep.css"

const A1ExamPrep = () => {
  return (
      <div className="a1ExamPrepCover">
        <h3>Goethe <span>A1 Exam</span> Preparation</h3>
        <p>
          A1 level is the beginner level. To prepare for the Goethe German A1
          test:
        </p>
        <ul>
          <li>
            Practice reading and understanding texts, such as brief notes,
            advertisements, signposts, and posters.
          </li>
          <li>
            Work on filling out forms and writing short texts about yourself on
            everyday topics.
          </li>
          <li>
            Work on filling out forms and writing short texts about yourself on
            everyday topic.
          </li>
        </ul>
      </div>
  );
};

export default A1ExamPrep;
